export const Navigation = {
  SCHEDULED_VISITS_HEADER: "Scheduled Visits",
  PENDING_FILES_HEADER: "Pending Files",
  SEARCH_ORDERS: "Search Orders",
};

export const Name = new Map([
  [1, {
    SCHEDULED_VISITS_HEADER: 'Scheduled Visits',
    PENDING_FILES_HEADER: 'Pending Files',
    PRESCRIBER_PORTAL_HEADER: 'Prescriber Portal',
    SEARCH_ORDERS: 'Search Orders',
    JUMP_TO_V2: 'Jump into version 2',
    JUMP_TO_V1: 'Jump into version 1',
  }],
  [2, {
    SCHEDULED_VISITS_HEADER: 'Scheduled Visits',
    PENDING_FILES_HEADER: 'Asynchronous Orders',
    PRESCRIBER_PORTAL_HEADER: 'Prescriber Portal',
    SEARCH_ORDERS: 'Search Orders',
    JUMP_TO_V1: 'Jump into version 1',
    JUMP_TO_V2: 'Jump into version 2',
  }]
]);

export default Navigation;
